var _circle, _circle2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSales(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sales",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.401,
    height: 20.368,
    viewBox: "0 0 22.401 20.368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 1.664,
    cy: 1.664,
    r: 1.664,
    transform: "translate(6.635 17.04)",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    cx: 1.664,
    cy: 1.664,
    r: 1.664,
    transform: "translate(16.986 17.04)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M16.883,15.751H8.515a3.121,3.121,0,0,1-3.1-2.51L3,2.953V2.9a1.053,1.053,0,0,0-1.034-.837H1.034A1.034,1.034,0,0,1,1.034,0h.935A3.107,3.107,0,0,1,5.021,2.51L7.432,12.8a1.064,1.064,0,0,0,1.083.886h8.368a1.938,1.938,0,0,0,1.87-1.477L20.279,6.5a1.042,1.042,0,0,0-.2-.935,1.1,1.1,0,0,0-.837-.443h-9.3a1.034,1.034,0,0,1,0-2.067h9.3A3.153,3.153,0,0,1,22.3,7.039l-1.526,5.71A4.048,4.048,0,0,1,16.883,15.751Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.81c9180e35f3bb82ed8453f89b50221c.svg";
export { ForwardRef as ReactComponent };